import { Controller } from "@hotwired/stimulus"
import React from "react"
import ReactDOM from "react-dom/client"
import ConversionScene from "../components/conversion-scene"

export default class extends Controller {

  connect() {
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(
      <ConversionScene/>
    )
  }

  disconnect() {
     this.root.unmount()
  }
  
}
